import { Controller } from "@hotwired/stimulus"

// Opens a slideover the moment the page lands (TASK-280.5): a works project
// created from Due drops the owner on the People step with "Invite a
// contractor" already open. Asks the page's slideover controller through its
// own `slideover:open-requested` window event (the same door the activity feed
// uses), after a tick so that controller has connected.
export default class extends Controller {
  static values = { src: String, title: String, direction: { type: String, default: "right" } }

  connect() {
    this.timer = setTimeout(() => {
      window.dispatchEvent(new CustomEvent("slideover:open-requested", {
        detail: { turboFrameSrc: this.srcValue, title: this.titleValue, direction: this.directionValue }
      }))
    }, 0)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
